<template>
  <div class="bg_video_mask" :style="{
  display: $store.state.app.video_dialog_isShow == true ? 'block' : 'none',
  '--btnUrl':btnUrl,
    }" :class="{'flv_play_btn_anmation': [5, 6].includes(videoData.play_btn_url), 'play_icon_url': videoData.play_btn_url}">
    <div class="popupBg popupBgForWin"></div>
    <div class="video_dialog">
      <div class="dialogVideoDiv">
        <div
        class="cancelDialogVideo iconfont icon-chuyidong" @click="closeVideoDialog"></div>
        <div class="clearmb">
          <div
          :style="{
            display:videoData.type !== 'common_code' ? 'block': 'none'
          }"
          preload="meta"
          class="local_add_video video-js vjs-default-skin vjs-big-play-centered"
          webkit-playsinline="true"
          x5-playsinline=""
          x5-video-player-fullscreen="true"
          x-webkit-airplay="allow"
          x5-video-player-type="h5"
          playsinline="true"
          role="region"
          aria-label="video player">
          <video
            playsinline="true"
            x5-video-player-type="h5"
            x-webkit-airplay="allow"
            x5-video-player-fullscreen="true"
            x5-playsinline=""
            webkit-playsinline="true"
            id="myVideo_local_add"
            class="vjs-tech"
            muted
            controls="true">
            <source class="videoSource" src="" type="video/mp4">{{$t('components_set_link_components_pop_video_2463')}}</video>
          </div>
          <div class="flv_play_inframe_wrap" v-if="videoData.type == 'common_code'">
              <div
              v-html="videoData.common_code.url">
              </div>
         </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import i18n from '../../../language/index'

  export default {
    name: 'pop_video_index',
    data() {
      return {
        btnIsShow: true
      };
    },
    computed: {
      videoData() {
        return this.$store.state.app.video_data
      },
      btnUrl() {
        return this.videoData.play_btn_url ? `url(https://sitecdn.71360.com/static/txys-001/assets/wmsite-xys-img/play_icon/play_icon${this.videoData.play_btn_url}.png)` : ''
      }
    },
    props: {
    },
    watch: {
      '$store.state.app.video_dialog_isShow'(val) {
        if(this.videoData.type !== 'common_code') {
          this.initVideo()
        }
      }
    },
    methods:{
      closeVideoDialog() {
        if(this.$store.state.app.video_data.type === 'local_add' || this.$store.state.app.video_data.type === 'video_address') {
          let myVideo = this.$video('myVideo_local_add')
          myVideo.pause()
        }
        this.$store.commit('app/set_video_dialog_isShow', false);
      },
      initVideo() {
        let that = this
        let video_data = that.$store.state.app.video_data
        let video_type = video_data.type
        let data = {src:video_data[video_type].url,type: 'video/mp4'}
        let myPlayer = that.$video(('myVideo_local_add'), {
                        controls: true,
                        muted: true,
                        autoplay: true,
                        loop: false,
                        language: 'zh-CN', // 设置语言
                        controlBar: {
                            children: [{name: 'playToggle'},//播放暂停按钮
                              {name: 'currentTimeDisplay'},
                              {name: 'timeDivider'},//分隔符
                              {name: 'durationDisplay'},// 总时间
                              {name: 'progressControl'},// 播放进度条
                              {name: 'volumePanel',inline: false},// 不使用水平方式// 音量控制
                              {name: 'fullscreenToggle'}// 全屏
                            ]
                          },
								  sources: []
            });
            myPlayer.src(data)
            myPlayer.load(data);
      }
    },
    components:{
    },
    mounted(){
    }
  }
</script>

<style scoped lang="scss">
@keyframes play_anmation{
  0% {
    transform: scale(0.5);
  }
  100% {
    transform: scale(1);
  }
}
  /* 视频弹窗 */
  .bg_video_mask {
  	display: none;
    &.flv_play_btn_anmation .video_dialog .dialogVideoDiv{
      background:red;
      /deep/ .video-js .vjs-big-play-button{
        &::before{
        top: -10px;
        left: -10px;
        content: "";
        width: 80px;
        height: 80px;
        position: absolute;
        border-radius: 100%;
        background: rgba(255, 255, 255, 0.2);
        animation: 1s play_anmation linear infinite;
        }
        &::after{
          top: -35px;
          left: -35px;
          content: "";
          width: 130px;
          height: 130px;
          position: absolute;
          border-radius: 100%;
          background: rgba(255, 255, 255, 0.2);
          animation: 1.5s play_anmation linear infinite;
        }
      }
    }
    &.play_icon_url{
      .video_dialog {
        /deep/ .video-js .vjs-big-play-button{
          font-size: 0 !important;
          background: var(--btnUrl) !important;
          width: 60px !important;
          height: 60px !important;
          margin-top: -30px !important;
          margin-left: -30px !important;
          border:none !important;
          background-size: 60px 60px !important;
        }
      }
    }
      .popupBg {
          position: fixed;
          margin: 0;
          padding: 0;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          height: 100%;
          background-color: #000;
          z-index: 9031;
          overflow: hidden;
          opacity: .3;
          -webkit-transition: all 3s;
          -o-transition: all 3s;
          -moz-transition: all 3s;
          transition: all 3s;
      }
      .video_dialog {
          position: fixed;
          z-index: 10000;
          left: 0;
          top: 0;
          right: 0;
          bottom: 0;
          margin: auto;
          .dialogVideoDiv {
            height: 100%;
            position: relative;
            .clearmb {
              background: #000;
              .local_add_video {
                .flv_play_btn{
                  position: absolute;
                  width: 60px;
                  height: 60px;
                  background: url(/static/image/backimg1.png) -116px -196px no-repeat;
                  top: 50%;
                  left: 50%;
                  margin-top: -30px;
                  margin-left: -30px;
                  z-index: 2;
                  cursor: pointer;
                }
              }
              .flv_play_inframe_wrap {
                position: absolute;
                width: 100%;
                padding-bottom: 58%;
                height: 0;
                top: 0;
                bottom: 0;
                margin: auto;
                .flv_play_inframe {
                    width: 100%;
                    height: 100%;
                    position: absolute;
                }
              }
            }
  			 .video-js .vjs-tech {
  				 position: absolute;
  				 top: 50%;
  				 left: 0;
  				 width: 100%;
  				 max-height: 100%;
  				 max-width: 100%;
  				 -webkit-transform: translate3d(0,-50%,0);
  				 -moz-transform: translate3d(0,-50%,0);
  				 transform: translate3d(0,-50%,0);
  			 }
            .cancelDialogVideo {
                z-index: 9999;
                right: 20px;
                cursor: pointer;
                font-size: 20px;
                color: #fff;
                position: absolute;
                margin-top: 14px;
            }
          }
      }
    }
</style>



// WEBPACK FOOTER //
// src/components/set_link/components/pop_video.vue